
import { Input, DatePicker, Select, Option } from "element-ui"

export default {
  name: "PersonalInformation",
  components: {
    [Input.name]: Input,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({
        name: "",
        email: "",
        birth: ""
      })
    },
    disabledBirth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(this.initialData)),
      unchangedForm: true
    }
  },
  watch: {
    initialData: {
      handler(val) {
        this.form = JSON.parse(JSON.stringify(val))
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleChanged() {
      this.unchangedForm = false
      this.$emit("change", this.form)
    },
    handleSubmit() {
      this.$emit("submit", this.form)
    }
  }
}
